export default {
  title: 'Addons',

  labels: {
    code: 'Code',
    name: 'Name',
    period: 'Period time',
    price: 'Monthly price ',
    salePrice: 'Sale price',
    product: 'Product',
    status: 'Addon is active',
    description: 'Description',
    delete: 'Delete'
  },

  table: {
    header: {
      row: 'Row',
      code: 'Code',
      name: 'Name',
      period: 'Period',
      price: 'Monthly price',
      activeApps: 'Active Apps',
      status: 'Status',
      delete: 'Delete',
      restore: 'Restore'
    }
  },

  notifications: {
    wrongInputValue: 'Input value is wrong',
    requiredModulesNotSelected: 'For enable this addon, {modules} required',
    insert: {
      success: 'Addon successfully created',
      error: 'Insert addon has error'
    },
    edit: {
      success: 'Addon successfully updated',
      error: 'Update addon has error'
    },
    delete: {
      success: 'Addon successfully removed',
      error: 'Delete addon has error'
    },
    restore: {
      success: 'Addon successfully restored',
      error: 'Restore addon has error'
    },
    editLimits: {
      success: 'Addon limits successfully updated',
      error: 'Update addon limits has error'
    },
    parseError: {
      name: 'Name is not valid',
      code: 'Code is not valid or is used to another addon',
      price: 'Price is not valid'
    }
  },

  validators: {
    permissions: 'No permission set for this addon'
  },

  confirmations: {
    delete: {
      title: 'Delete addon confirmation',
      body: 'Are you sure about delete this addon?'
    }
  },

  slugName: {
    users: 'Users ',
    products: 'Products ',
    advanced_products: 'Advanced products',
    services: 'Services ',
    sales: 'Sales',
    purchases: 'Purchases',
    treasury: 'Treasury',
    events: 'Events',
    support_tickets: 'Support Tickets',
    financial_years: 'Financial Years',
    settings: 'Settings',
    point: 'Point',
    max_debt: 'Credit',
    users_group: 'Users group',
    deficits: 'Deficits',
    conversions: 'Conversions',
    costs: 'Costs',
    sale_suggest: 'Sale suggest',
    purchase_suggest: 'Purchase suggest',
    reports: 'Reports',
    points: 'Points',
    roles: 'Roles',
    warehouses: 'Warehouses',
    accountancy: 'Accountancy',
    organizational_tickets: 'Internal Tickets',
    woocommerce: 'Woocommerce',
    connector: 'Woocommerce',
    backups: 'Backups',
    company: 'Company',
    addons: {
      points: 'Point',
      max_debt: 'Credit',
      users_group: 'Users group',
      deficits: 'Deficits',
      conversions: 'Conversions',
      costs: 'Costs',
      cost: 'Cost',
      tax: 'Vat',
      opening_inventory: 'Opening inventory',
      ai_suggest: 'Ai Suggest',
      advanced_purchase: 'Advanced purchase',
      advanced_sale: 'Advanced sale',
      woocommerce_connector: 'Woocommerce connector',
      cross_currency_pricing: 'Cross currency pricing',
      sale_report_by_attributes: 'Sale report by attribute',
      sale_report_by_customer: 'Sale report by customer',
    }
  },

  statusTypes: {
    active: 'Active',
    disable: 'Disable'
  },

  list: {
    title: 'Addons'
  },

  trash: {
    title: 'Removed addons'
  },

  insert: {
    title: 'Create Addon'
  },

  edit: {
    title: 'Edit addon',
    dynamicTitle: 'Edit {name} addon'
  },

  profile: {
    title: 'Addon profile',
    dynamicTitle: '{name} addon profile',

    importantData: {
      code: 'Code',
      price: 'Price',
      status: 'Status'
    },

    actions: {
      apps: 'Apps',
      limits: 'Limits',
      logs: 'Activity logs'
    }
  },

  apps: {
    title: 'Addon apps list'
  },

  limits: {
    title: 'Addon limits',

    labels: {
      inMenu: 'Menu'
    }
  },

  logs: {
    title: 'Addon Logs'
  }
}
